import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class SystemUpdateGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var systemUpdateGrid = this;
		setTimeout(function(){
			systemUpdateGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var systemUpdateGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['DATA_FILTER_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'updateId',
					header: 'Update Id',
					width: '7em'
				},
				{						
					path: 'updateNote',
					header: 'Description',
					width: '7em'
				},	
				{						
					path: 'updateStatusDescription',
					header: 'Update Status',
					width: '7em',
					renderer: function(root, column, rowData) {
						var status = '';
						if (rowData.item.updateStatus === 'SCHEDULED') {
							status = '<span style="color: white; background-color: darkgrey; padding: 3px;">' + rowData.item.updateStatusDescription + '</span>';
						} else if (rowData.item.updateStatus === 'IN_PROGRESS') {
							status = '<span style="color: white; background-color: cornflowerblue; padding: 3px;">' + rowData.item.updateStatusDescription + '</span>';
						} else if (rowData.item.updateStatus === 'READY') {	
							status = '<span style="color: lightgreen; background-color: darkgreen; padding: 3px;">' + rowData.item.updateStatusDescription + '</span>';
						} else {
							status = rowData.item.updateStatusDescription;
						}
						
						root.innerHTML = status;
					}
				},	
				{						
					path: 'actionViews',
					header: 'Actions',
					width: '7em',
					renderer: function(root, column, rowData) {
						var actions = [];
						if (rowData.item.actionViews) {
							rowData.item.actionViews.forEach(function(action){
								actions.push(
									'Type: ' + action.actionTypeDescription + 
									'<br>Status: ' + action.actionStatusDescription + 
									'<br>Minutes: ' + action.minuteToApplyBefore
								);
							});
						}						
						root.innerHTML = actions.join('<hr>');
					}
				},
				{						
					path: 'scheduleDts',
					header: 'Schedule Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.scheduleDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},	
				{						
					path: 'expectedCompleteDts',
					header: 'Expected Complete Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.expectedCompleteDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},					
				{						
					path: 'sendNotification',
					header: 'Send Notifications',
					width: '7em'
				},
				{						
					path: 'notificationSentDts',
					header: 'Notificaiton Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.notificationSentDts) {
							var date = TimeUtil.parseDate(rowData.item.notificationSentDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = '(Not Sent)';
						}
					}
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'system-updates',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});
		systemUpdateGrid.append(flexLayout);
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			Service.getSystemUpdateService().getUpdates().then(function(updates){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = updates.data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var actions = [];
						var actionGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [								
								{						
									path: 'actionTypeDescription',
									header: 'Action Type',					
									width: '9em'
								},								
								{
									path: 'actionStatusDescription',
									header: 'Status',
									width: '9em'
								},
								{
									path: 'minuteToApplyBefore',
									header: 'Minutes To Apply (Before)',
									width: '9em'
								},
								{
									path: 'propertyValue',
									header: 'Property Value',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									actionGrid.selectedItems = item ? [item] : [];
									if (actionGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editAction').disabled = false;										
										ElementUtil.query(formPanel, 'removeAction').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'editAction').disabled = true;										
										ElementUtil.query(formPanel, 'removeAction').disabled = true;
									}	
								}
							}
						});
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'updateNote',
											label: 'Description',											
											required: true,
											colspan: 2,
											maxLength: 80											
										},
										{
											tag: 'vaadin-date-time-picker',
											itemId: 'startDate',
											label: 'Start Date(mm/dd/yyyy hh:mm:ss)',
											name: 'scheduleDts',
											step: 1,
											value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
											max: TimeUtil.formatDateForDateLoad(new Date()) + 'T01:00:00',
											required: true,
											listeners: {
												change: function(e) {
													var startDts = ElementUtil.query(formPanel, 'startDate').value;
													ElementUtil.query(formPanel, 'endDate').min = startDts;
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											itemId: 'endDate',
											label: 'Expected End Date(mm/dd/yyyy hh:mm:ss)',
											name: 'expectedCompleteDts',
											step: 1,
											min: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
											value: TimeUtil.formatDateForDateLoad(new Date()) + 'T01:00:00',
											required: true,
											listeners: {
												change: function(e) {
													var endDate = ElementUtil.query(formPanel, 'endDate').value;
													ElementUtil.query(formPanel, 'startDate').max = endDate;
												}
											}
										},
										{
											tag: 'vaadin-text-area',										
											name: 'updateMessage',
											label: 'Notification Message',																					
											colspan: 2,
											maxLength: 1024											
										},
										{
											tag: 'vaadin-checkbox',
											name: 'sendNotification',
											label: 'Send Notification'
										},
										{
											tag: 'vaadin-number-field',										
											name: 'notificationDelayMinutes',
											label: 'Notification Delay',																						
											min: 0,
											max: 100000
										},
										{
											tag: 'dl-section-title',
											title: 'Action',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											style: 'height: 350px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [														
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',																	
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditAction();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editAction',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditAction(actionGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeAction',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveAction(actionGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														actionGrid													
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																														
															formPanel.submitForm({
																preSubmit: function (data) {
																	if (data.notificationDelayMinutes === '') {
																		delete data.notificationDelayMinutes;
																	}

																	//add actions
																	data.actions = actions;
																	return data;
																},
																actualCall: function (data) {
																	if (record) {
																		data.updateId = record.updateId;
																	}
																	return Service.getSystemUpdateService().saveUpdate(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved System Update', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var actionRefreshActions = function() {														
							actionGrid.activeItem = null;
							actionGrid.items = actions.slice(0);	
						};
						
						if (record) {	
							formPanel.load(record);
							
							//load rules
							actions = [];							
							record.actionViews.forEach(function(action){										
								actions.push(Object.assign({}, action));
							});
							
							actionRefreshActions();
						}
						
						var actionRemoveAction = function(action) {
							var newItems = [];
							actions.forEach(function(item){
								if (!(item.actionType === action.actionType &&
									item.propertyValue === action.propertyValue)) {
									newItems.push(item);
								}
							});	
							actions = newItems;
							actionRefreshActions();
						};
						
						var actionAddEditAction = function(action) {
							
							var addEditActionWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: action ? 'Edit' : 'Add',
								icon: 'vaadin:edit',
								width: 600,
								height: 500,
								listeners: {
									ready: function () {
										addEditActionWin.show();									
								
										
										var actionFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																												
														{
															tag: 'vaadin-combo-box',															
															itemid: 'actionType',
															name: 'actionType',															
															label: 'Action Type',
															'item-value-path': 'code',
															'item-label-path': 'description',															
															required: true,
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('SystemActionType').then(function(data) {																	
																	combo.items = data;																	
																});
															},															
															placeHolder: 'Select'
														},
														{
															tag: 'vaadin-number-field',
															name: 'minuteToApplyBefore',
															label: 'Apply Before Start (Minutes)',
															min: 0,
															max: 100000
														},
														{
															tag: 'vaadin-text-field',
															name: 'propertyValue',
															label: 'Property Value',																
															maxLength: 255
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', (action ? ' Update' : ' Add'))
																	],
																	listeners: {
																		click: function() {															

																			//must have either a include or exclude

																			//get data
																			var data = actionFormPanel.getData();
																																				
																			data.actionTypeDescription = ElementUtil.query(actionFormPanel, 'actionType').selectedItem.description;
																			
																			//add record
																			if (!action) {
																				data.actionStatusDescription = 'N/A';
																				actions.push(data);																			
																			} else {
																				action.actionType = data.actionType;
																				action.actionTypeDescription = data.actionTypeDescription;
																				action.minuteToApplyBefore = data.minuteToApplyBefore;
																				action.propertyValue = data.propertyValue;																			
																			}
																			
																			//refresh rules
																			actionRefreshActions();
																			addEditActionWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addEditActionWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});			

										addEditActionWin.addToContentElement(actionFormPanel);
										
										
										if (action) {
											actionFormPanel.load(action);											
										}
										
									}
								}
							});
							
						};
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.updateNote + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i> Actions may need to manually reset.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							Service.getSystemUpdateService().deleteUpdate(record.updateId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.updateNote, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
	}
	
}
customElements.define('dl-systemupdate-grid', SystemUpdateGrid);